export default __webpack_public_path__ + "static/Ray.Stark_social-9c49ee9286da5710e4cb324dc0f6ad7a.jpg";